export default "__VITE_ASSET__68da1f8b__"